// extracted by mini-css-extract-plugin
export default {"wellSelect":"selects_wellSelect__SQ548","drillingIcon":"selects_drillingIcon__rJ0Wd","wellboreSelect":"selects_wellboreSelect__l5Lp2"};